import { render, staticRenderFns } from "./TechInfoContainer.vue?vue&type=template&id=29b9c37e&scoped=true&"
import script from "./TechInfoContainer.vue?vue&type=script&lang=js&"
export * from "./TechInfoContainer.vue?vue&type=script&lang=js&"
import style0 from "./TechInfoContainer.vue?vue&type=style&index=0&id=29b9c37e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b9c37e",
  null
  
)

export default component.exports